/**
 * Safely execute a function and return a default value on error
 * @param {Function} fn - Function to execute safely
 * @param {*} defaultVal - Default value to return on error
 * @returns {*} Function result or default value
 */
export function getSafe(fn, defaultVal) {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
}

/**
 * Safely get an array element at a specific index
 * @param {Array} array - Array to access
 * @param {number} index - Index to access
 * @param {*} fallback - Fallback value (default: null)
 * @returns {*} Array element or fallback value
 */
export function getSafeArrayElement(array, index, fallback = null) {
  try {
    return array && Array.isArray(array) && array.length > index && index >= 0
      ? array[index]
      : fallback;
  } catch (e) {
    return fallback;
  }
}

/**
 * Validate email address format
 * @param {string} email - Email address to validate
 * @returns {boolean} True if email is valid
 */
export function validateEmail(email) {
  const re =
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}